export { default } from './HeaderMonarchLoggedOutController';
